import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import WordCardRow from 'components/word_card/word_card_row';
import WordCardTitle from 'components/word_card/word_card_title';
import ConjugationTable from 'components/conjugation_table';
import { TableIcon } from '@seedlang/icons';

const Wrapper = styled.div`
  width: 100%;
  .table-icon { svg { width: 20px; } }
  .icon-wrapper {
    width: 20px;
    svg {
      fill: #000;
    }
  }
`;

const ConjugationTableWrapper = styled.div`
  margin-top: 10px;
`;

@observer
class WordCardConjugationRow extends React.Component {
  render() {
    if (!this.props.word) {
      return null;
    }

    return (
      <Wrapper>
        <WordCardRow
          id={this.props.id || 'conjugation-table'}
          expandedId={this.props.expandedId}
          onClick={this.props.onClickRow}
          rowMargin={this.props.rowMargin}
        >
          <WordCardTitle
            icon={<TableIcon />}
            displayNameLine1WithCase={this.props.displayNameLine1WithCase || (this.props.word.isInfinitive ? 'Conjugation Tables' : 'Conjugation Table')}
            displayNameLine2={this.props.displayNameLine2 || this.props.word.conjugatedVerbStringsSummary}
          />
          <ConjugationTableWrapper>
            <ConjugationTable
              inDeck
              word={this.props.word}
              {...this.props.conjugationTableProps}
            />
          </ConjugationTableWrapper>
        </WordCardRow>
      </Wrapper>
    );
  }
}

export default WordCardConjugationRow;
